module.exports = __webpack_public_path__ + "media/images/faq/5-100-3d6c4e05d13d87f1f44a248e8edeee07.jpg";